import { render, staticRenderFns } from "./AppMainMenu.vue?vue&type=template&id=19b750fb&lang=pug&"
import script from "./AppMainMenu.vue?vue&type=script&lang=js&"
export * from "./AppMainMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports